/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Export_CsvInputs */

const en_reports_export_csv = /** @type {(inputs: Reports_Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV`)
};

const pt_br2_reports_export_csv = /** @type {(inputs: Reports_Export_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV`)
};

/**
* | output |
* | --- |
* | "CSV" |
*
* @param {Reports_Export_CsvInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_export_csv = /** @type {((inputs?: Reports_Export_CsvInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Export_CsvInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_export_csv(inputs)
	return pt_br2_reports_export_csv(inputs)
});